<template>
  <div id="orderFormByChannel3" :style="{ backgroundColor: color }">

    <div class="ticketGetRow orderFormByChannel3-div">


      <div class="flex-start">
        <div>当前票号 : {{ ticketGetRow.ticketCurrentNo }}</div>
        <div style="margin-left: 30px">剩余票张数 : {{ ticketGetRow.remainingNum }}</div>
      </div>
      <div class="flex-start">
        <div class="flex-center" style="margin-right: 20px;">
          <el-tooltip class="item" effect="dark" content="设置背景色" placement="top">
            <el-color-picker @change="colorChange" v-model="color"></el-color-picker>
          </el-tooltip>

        </div>

        <el-button size="medium" type="primary" v-if="menuPreFn(82)" @click="$router.push('/occupySeat')">占座
        </el-button>
        <el-button size="medium" type="danger" @click="cancelShow = true">作废</el-button>
        <el-button size="medium" type="primary" @click="ticketShow = true">售票统计</el-button>
      </div>
    </div>


    <el-form class="orderFormByChannel3-div" :model="form" :rules="rules" ref="form" label-width="110px"
      label-position="top" style="margin-bottom:0">
      <div class="flex-between">
        <div class="orderFormByChannel3-title">窗口售票</div>
        <el-button type="primary" @click="refresh">刷新线路/班次</el-button>
      </div>
      <div style="padding: 20px 0; line-height: 18px">
        <p class="util-remark">
          * 无论是总公司，还是分公司，都只能选择自己机构下的线路进行下单
        </p>
      </div>


      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="乘车日期" prop="schedulingTime">
            <el-date-picker ref="f1Ref" style="width: 100%" @change="timeChange" v-model="form.schedulingTime"
              type="date" :picker-options="pickerOptions" value-format="timestamp" placeholder="请选择乘车日期">
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="发站" prop="startStationCode">
            <el-select ref="f2Ref" @change="stationChange" :value="form.startStationCodeName" filterable>
              <el-option v-for="(item, i) in startStations" :key="i" :value="item.stationCode"
                :label="`${item.mnemonicCode}-${item.stationName}-${item.stationCode}`">
                {{ `${item.mnemonicCode}-${item.stationName}` }}
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>


        <el-col :span="8">
          <el-form-item label="到站" prop="endStationCode">
            <el-select ref="f3Ref" @change="endStationChange" :value="form.endStationCodeName" filterable>
              <el-option v-for="(item, i) in stationsList" :key="i" :value="item.stationCode"
                :label="`${item.mnemonicCode}-${item.stationName}-${item.stationPinyin}-${item.stationCode}`">
                {{ `${item.mnemonicCode}-${item.stationName}` }}
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>


      <el-form-item label="选择班次" prop="schedulingId">
        <el-select @change="schedulingChange" :disabled="!(form.startStationCode && form.endStationCode)" ref="f4Ref"
          no-data-text="没有可售班次，请重新输入！" v-model="form.schedulingId" filterable
          :placeholder="!(form.startStationCode && form.endStationCode) ? '无售票信息' : '请选择班次'">
          <el-option :disabled="item.ticketNumType == 2 && !item.remainingTickets" v-for="(item, i) in lines" :key="i"
            :value="item.schedulingId" :label="`${$utils.timeFn(form.schedulingTime, 'YYYY/MM/DD')}
                     ${item.startTime}
                     余${item.remainingTickets}
                     ¥${item.fee}
                     ${item.isCompensateTicket == 1 && item.status == 2 ? '(可补票)' : ''}
                     ${item.startStationName}-${item.endStationName}
                     `">
          </el-option>
        </el-select>
      </el-form-item>

      <div v-if="form.schedulingId">
        <el-form-item label="乘客身份信息" required label-width="100%" v-if="form.ticketRestrictions === 2">

          <el-table border empty-text="暂无数据" :data="form.customers">
            <el-table-column label="姓名" prop="name" v-slot="{ row, $index }" width="120">
              <el-form-item class="checkItem" :prop="'customers.' + $index + '.name'"
                :rules="[{ required: true, message: '请输入姓名', trigger: ['blur', 'change'] }]">
                <el-input v-model="row.name" maxlength="10" />
              </el-form-item>

            </el-table-column>
            <el-table-column label="证件类型" prop="cardType" v-slot="{ row, $index }" width="155">
              <el-form-item class="checkItem" :prop="'customers.' + $index + '.cardType'">
                <el-select v-model="row.cardType" placeholder="请选择证件类型" @change="row.idCard = ''">
                  <el-option v-for="(item, i) in $const.CARDTYPELIST" :key="i" :value="item.value"
                    :label="item.label"></el-option>
                </el-select>
              </el-form-item>

            </el-table-column>
            <el-table-column label="证件号码" prop="idCard" v-slot="{ row, $index }" width="175">
              <el-form-item class="checkItem" :prop="'customers.' + $index + '.idCard'" :rules="[{
                pattern: $const.CARDRULES[row.cardType || 1].rules,
                message: '请输入正确的证件号码',
                trigger: ['blur', 'change'],
                required: true
              }]">
                <el-input v-model="row.idCard"
                  @input="row.idCard = row.idCard.toLocaleUpperCase(); $refs.form.validateField('customers')"
                  :maxlength="$const.CARDRULES[row.cardType || 1].maxLength" />
              </el-form-item>
            </el-table-column>

            <el-table-column label="手机号码" prop="phone" v-slot="{ row, $index }" width="130">
              <el-form-item class="checkItem" :prop="'customers.' + $index + '.phone'" :rules="[{
                pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
                message: '请输入正确手机号',
                trigger: ['blur', 'change'],
              }]">
                <el-input v-model="row.phone" placeholder="选填"
                  @input="row.phone = row.phone.replace(/[^\d]/g, ''); $refs.form.validateField('customers')"
                  maxlength="11" />
              </el-form-item>
            </el-table-column>

            <el-table-column label="联系人" v-slot="{ $index }" width="62" align="center">
              <div class="flex-center orderFormByChannel3-user">
                <el-radio v-model="isDefault" :label="$index" />
              </div>
            </el-table-column>
            <el-table-column label="车票类型" v-slot="{ row, $index }" width="135">
              <el-select @change="ticketChange(row, $index)" v-model="row.ticketType" class="nocheck">

                <el-option v-if="stationTicketType.includes(item.value)" :key="item.value"
                  v-for="item in $const.TICKETTYPE" :label="item.label" :value="item.value" />
              </el-select>
            </el-table-column>

            <el-table-column label="票价" prop="phone" v-slot="{ row, $index }" width="130">
              <el-form-item class="checkItem" :prop="'customers.' + $index + '.ticketFee'" :rules="[{
                required: true,
                message: '请输入票价',
                trigger: ['blur', 'change'],
              }]">
                <el-input :disabled="systemOrderFeeChange == 1 ? [3, 4].includes(row.ticketType) : true"
                  v-input-filter="{ min: 0.01, max: 999, precision: 2 }" v-model="row.ticketFee" placeholder="票价">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-table-column>
            <el-table-column label="操作" v-slot="{ $index }" width="90">
              <el-button type="text" :disabled="!(form.customers.length > 1)" @click="deleteCustomer($index)">删除
              </el-button>
              <el-button type="text" @click="readCard($index)">读卡</el-button>
            </el-table-column>
          </el-table>
          <el-button v-show="form.customers && form.customers.length < 8" class="add" @click="addCustomer">
            <i class="el-icon-circle-plus-outline"></i> 添加
          </el-button>
        </el-form-item>

        <el-row :gutter="20" v-if="form.ticketRestrictions === 1">
          <el-col :span="8">
            <el-form-item label="购票数量" prop="passengerNum">
              <el-radio-group v-model="form.passengerNum" size="mini">
                <el-radio-button v-for=" item in 5" :label="item" :key="item"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话" prop="customerPhone">
              <el-input placeholder="接收行程短信的手机号码 (选填)" v-model="form.customerPhone" maxlength="11"></el-input>
            </el-form-item>
          </el-col>

        </el-row>


        <el-row :gutter="20">
          <!--          <el-col :span="8">-->
          <!--            <el-form-item label="保险张数" prop="insuranceNum">-->
          <!--              <el-input ref="f7Ref" style="width: 100%;" v-model="form.insuranceNum"-->
          <!--                        @input="form.insuranceNum = form.insuranceNum.replace(/^0|[^\d]/g, '')" maxlength="2">-->
          <!--                <template slot="append">张</template>-->
          <!--              </el-input>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
          <!--          <el-col :span="8">-->
          <!--            <el-form-item label="保险金额" prop="insuranceFee">-->
          <!--              <el-input ref="f8Ref" style="width: 100%;" v-model="form.insuranceFee"-->
          <!--                        @input="form.insuranceFee = form.insuranceFee.replace(/^0[\d]/g, '0').replace(/^[1-9][0-9]{3,}/g, '999').replace(/(\d{1,3}\.?\d{0,1})?.*/g, '$1'); calcFeeOfPeople();">-->
          <!--                <template slot="append">元</template>-->
          <!--              </el-input>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
          <el-col :span="8">
            <el-form-item label="下单备注" prop="remark">
              <el-input v-model="form.remark" maxlength="30" style="width: 100%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收款方式" prop="payChannel">
              <el-radio-group v-model="form.payChannel">
                <el-radio label="CHANNEL_COLLECTION_CODE">二维码收款</el-radio>
                <el-radio label="CHANNEL_CASH">现金</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>


          <el-col :span="8">
            <el-form-item label="合计金额" prop="fee">
              <div class="flex-start">
                <div style="font-size: 30px;color: #ff9900;margin-right: 10px">¥{{ form.fee }}</div>

                <div class="flex-start" v-if="form.payChannel === 'CHANNEL_CASH'">付款：
                  <el-input v-input-filter="{ min: 0.01, max: 999, precision: 2 }" v-model="payMoney" maxlength="30"
                    style="width: 80px;"></el-input>
                  <span style="margin-left: 10px">
                    找补：<span v-if="payMoney">{{ ((payMoney * 100 - Number(form.fee) * 100) / 100).toFixed(2) }}</span>
                  </span>
                </div>
              </div>
            </el-form-item>
          </el-col>


        </el-row>
      </div>


    </el-form>

    <div v-if="form.schedulingId" class="main-form-btn orderFormByChannel3-div" style="margin-top: 20px">
      <el-button @click="$router.back()">取消</el-button>
      <el-button type="primary" @click="saveClick" :loading="loading">确定</el-button>
    </div>

    <selectVote v-model="voteShow" @handChange="handChange"></selectVote>

    <printDialog @lookCardFn="readCard2" ref="printDialog" v-model="dialogVisible2" :printListLoading="printListLoading"
      :list="printList" @printListClose="printListClose"></printDialog>

    <ticketSales v-model="ticketShow"></ticketSales>

    <cancellation @handChange="handChange" :ticketGetRow="ticketGetRow" v-model="cancelShow"></cancellation>

  </div>
</template>

<script>
import selectVote from './components/selectVote'
import printDialog from "./components/printDialog";
import ticketSales from "./components/ticketSales";
import cancellation from "./components/cancellation";

export default {
  name: "orderFormByChannel3",
  components: {
    selectVote,
    printDialog,
    ticketSales,
    cancellation
  },
  data() {
    const validateInsuranceNum = (rule, value, callback) => {
      if (!this.form.insuranceNum && this.form.insuranceFee) {
        return callback(new Error('请填写保险张数'))
      } else if (this.form.insuranceNum) {
        if (this.form.ticketRestrictions === 1) {
          if (this.form.insuranceNum > this.form.passengerNum) {
            return callback(new Error('保险张数不能大于乘客人数'))
          }
        } else {
          if (this.form.insuranceNum > this.form.customers.length) {
            return callback(new Error('保险张数不能大于乘客人数'))
          }
        }
        return callback()
      } else {
        return callback()
      }

    }
    const validateInsuranceFee = (rule, value, callback) => {
      if (!this.form.insuranceFee && this.form.insuranceNum) {
        return callback(new Error('请填写保险金额'))
      } else {
        return callback()
      }
    }

    const validatePassengerNum = (rule, value, callback) => {
      const find = this.lines.find((item) => item.schedulingId === this.form.schedulingId)
      if (this.form.passengerNum > find.remainingTickets) {
        return callback(new Error('购票张数不能大于余票张数'))
      } else {
        return callback()
      }
    }


    return {
      color: '#454545',
      cancelShow: false,
      ticketShow: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //设置选择今天之前的日期（不能选择当天）
        },
      },
      voteShow: true,
      form: {
        ticketRestrictions: '',
        schedulingTime: new Date().setHours(0, 0, 0, 0),
        startStationCode: "",
        startStationCodeName: "",
        endStationCode: "",
        endStationCodeName: "",
        schedulingId: "",
        insuranceNum: '',
        insuranceFee: "",
        remark: "",
        payChannel: "CHANNEL_CASH",
        fee: "",
        passengerNum: 1,
        ticketNum: "",// 半票 全票
        customerPhone: "",
        customers: [],
      },
      rules: {
        schedulingTime: [{ required: true, message: '请选择乘车日期', trigger: ['blur', 'change'] }],
        startStationCode: [{ required: true, message: '请选择发站地点', trigger: ['blur', 'change'] }],
        endStationCode: [{ required: true, message: '请选择到站地点', trigger: ['blur', 'change'] }],
        schedulingId: [{ required: true, message: '请选择班次', trigger: ['blur', 'change'] }],
        payChannel: [{ required: true, message: '请选择支付方式', trigger: ['blur', 'change'] }],
        insuranceNum: [{
          validator: validateInsuranceNum,
          trigger: ['blur', 'change']
        }],
        insuranceFee: [{
          validator: validateInsuranceFee,
          trigger: ['blur', 'change']
        }],
        passengerNum: [{ required: true, message: '请选择购票数量', trigger: ['blur', 'change'] }, {
          validator: validatePassengerNum,
          trigger: ['blur', 'change']
        }],

      },
      ticketGetRow: {},

      lines: [],
      linesSource: [],
      startStations: [],
      stationsList: [],
      isDefault: 0,
      stationTicketType: [],
      systemOrderFeeChange: "",
      loading: false,

      dialogVisible2: false,
      printListLoading: false,
      printList: [],
      getPrintListTimer: null,
      readIndex: 0,
      readSwitch: false,
      readIndexLook: 0,
      ws: null,
      timer: null,
      payStatus: false,
      payMoney: '',
      readSwitchNoUser: false
    }
  },
  watch: {
    'form': {
      handler() {
        if (this.payStatus) return
        this.calcFeeOfPeople()
      },
      deep: true,
    }
  },
  mounted() {
    this.color = sessionStorage.getItem('color' + this.mixinUserInfo.id) || '#454545'
    this.connectionCardReader();
    // this.getStartInitFn()
    this.getEndInitFn()
    this.getTicketRestrictions()
    document.addEventListener('keydown', this.keydownFn)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.keydownFn)
  },
  methods: {

    colorChange() {
      sessionStorage.setItem('color' + this.mixinUserInfo.id, this.color)
    },
    ticketChange(row, num) {
      const find = this.lines.find((item) => item.schedulingId === this.form.schedulingId)
      const arr = [find.fee, ((find.fee * 100) / 2) / 100, 0, 0]
      console.log(row, num, 1111);
      this.$set(this.form.customers, num, { ...row, ticketFee: arr[row.ticketType - 1] })
    },

    cardReadInfo() {
      const szJson = '{"Cmd":10000,"Head":"YZWL","IPFlag":"MGEyZmU1NmY5ODZlZGMyNg==","UserParam":"eyJBcHBLZXkiOiI5OWZmYjJmOThhMjkwNzExMDdjN2EwOWFkMmM2ZDA5NiIsIkRlY29kZVBob3RvIjp0cnVlLCJGYWNlQ29tcGFyZSI6ZmFsc2UsIlBob3RvRm9ybWF0IjoxLCJTZXJ2ZXJJUCI6ImlkLnl6ZnV0dXJlLmNuIiwiU2VydmVyUG9ydCI6ODg0OH0NCg==","Version":"V1.0.0"}\n'
      this.ws.send(szJson)
    },
    connectionCardReader() {
      const webUrl = 'ws://' + '127.0.0.1:30004'
      this.ws = new WebSocket(webUrl)
      this.ws.onopen = () => {
        console.log('读卡器驱动websocket连接成功');
      }
      this.ws.onclose = () => {
        console.log('读卡器驱动websocket已断开')
      }
      this.ws.onmessage = (messageEvent) => {
        console.log(messageEvent, 'yiccicicici')

        const jsonobject = JSON.parse(messageEvent.data)
        if (jsonobject.Ret == 0) {
          if (jsonobject.Cmd == 10001) {
            const szparam = JSON.parse(window.atob(jsonobject.UserParam))

            let hex2a = (hex) => {
              let str_list = ''
              for (let i = 0; i < hex.length && hex.substr(i, 2) !== '00'; i += 2) {
                const a = hex.charCodeAt(i)
                const b = hex.charCodeAt(i + 1)
                const c = b * 256 + a
                str_list += String.fromCharCode(c)
              }
              return str_list.toString()
            }

            let parseDateString = (str, deco, zero) => {
              let year = str.substr(0, 4)
              let month = str.substr(4, 2)
              let date = str.substr(6)
              if (zero) {
                month = month.substr(0, 1) === "0" ? month.substr(1) : month
                date = date.substr(0, 1) === "0" ? date.substr(1) : date
              }
              return `${year}${deco}${month}${deco}${date}`
            }
            let birthday = hex2a(window.atob(szparam.CardInfo.Birthday))
            let birthArr = parseDateString(birthday, ".", true).split(".")

            let info = {
              name: hex2a(window.atob(szparam.CardInfo.Name)).trim(),
              idCard: hex2a(window.atob(szparam.CardInfo.No)),
              // sex: hex2a(window.atob(szparam.CardInfo.Sex)),
              // nation: hex2a(window.atob(szparam.CardInfo.Nation)),
              // birthday: hex2a(window.atob(szparam.CardInfo.Birthday)),
              // year: birthday[0],
              // month: birthArr[1],
              // date: birthArr[2],
              // address: hex2a(window.atob(szparam.CardInfo.Address)),

              // signedDepartment: hex2a(window.atob(szparam.CardInfo.SignedDepartment)).trim(),
              // validityPeriodBegin: hex2a(window.atob(szparam.CardInfo.ValidityPeriodBegin)),
              // validityPeriodEnd: hex2a(window.atob(szparam.CardInfo.ValidityPeriodEnd))
            }
            // printDialog 探矿调用读卡
            if (this.readSwitchNoUser) {
              this.$ref.printDialog.loadData = {
                ...this.$ref.printDialog.loadData,
                customerName: info.name,
                idCard: info.idCard,
                cardType: 1
              }
              this.readSwitchNoUser = false
              return;
            }


            if (!this.form.schedulingId) return

            if (this.form.customers.length >= 8) return
            const isIdCard = this.form.customers.some((item) => item.name == info.name && item.idCard == info.idCard)
            if (isIdCard) {
              this.$message.error('乘客信息已存在')
              return
            }


            if (this.readSwitch) {
              this.$set(this.form.customers[this.readIndexLook], 'name', info.name)
              this.$set(this.form.customers[this.readIndexLook], 'idCard', info.idCard)
              this.$set(this.form.customers[this.readIndexLook], 'cardType', 1)
              this.readSwitch = false
              return
            }
            const find = this.lines.find((item) => item.schedulingId === this.form.schedulingId)

            if (this.readIndex === 0) {
              this.$set(this.form.customers[this.readIndex], 'name', info.name)
              this.$set(this.form.customers[this.readIndex], 'idCard', info.idCard)
              this.$set(this.form.customers[this.readIndex], 'cardType', 1)
              this.readIndex++
            } else {
              if (this.readIndex === this.form.customers.length) {
                this.form.customers.push({
                  idCard: '',
                  name: "",
                  phone: "",
                  ticketType: 1,
                  ticketFee: find.fee,
                })
                this.$set(this.form.customers[this.readIndex], 'name', info.name)
                this.$set(this.form.customers[this.readIndex], 'idCard', info.idCard)
                this.$set(this.form.customers[this.readIndex], 'cardType', 1)
                this.readIndex++
              } else {
                this.$set(this.form.customers[this.readIndex], 'name', info.name)
                this.$set(this.form.customers[this.readIndex], 'idCard', info.idCard)
                this.$set(this.form.customers[this.readIndex], 'cardType', 1)
                this.readIndex++
              }
            }
          } else if (jsonobject.Cmd == 1000) {
            let szparam = JSON.parse(window.atob(jsonobject.UserParam));
            if (szparam.State == 0) {
              this.$message.info('读卡器已被拔出');
              this.readIndex = null;
            }
          }
        } else {
          this.$message.info('读卡失败，原因：' + jsonobject.ErrInfo);
        }
      }
    },

    keydownFn(event) {

      if (event.key === 'F1') {
        this.$refs.f1Ref.focus()
      }

      if (event.key === 'F2') {
        this.$refs.f2Ref.focus()
      }
      if (event.key === 'F3') {
        this.$refs.f3Ref.focus()
      }

      // if (event.key === 'F4') {
      //   this.$refs.f4Ref.focus()
      // }
      if (event.key === 'F7') {
        this.$refs.f7Ref.focus()
      }
      if (event.key === 'F8') {
        this.$refs.f8Ref.focus()
      }

      if (event.key === 'Enter') {
        if (!this.form.schedulingId) return
        this.saveClick()
      }


    },
    printListClose() {
      if (this.getPrintListTimer) clearInterval(this.getPrintListTimer)
      this.form.schedulingId = ''
      this.$refs.f4Ref.visible = true
    },
    calcFeeOfPeople() {
      if (!this.form.schedulingId) return
      let fee = 0
      const find = this.lines.find((item) => item.schedulingId === this.form.schedulingId)
      if (find && this.form.ticketRestrictions == 1) {
        fee = find.fee * this.form.passengerNum + Number(this.form.insuranceFee || 0);

      } else {

        console.log(fee, 'wdes');
        this.form.customers.map(item => {
          fee += Number(item.ticketFee)
        })
        fee = (fee + Number(this.form.insuranceFee || 0)).toFixed(2);
      }

      // console.log(parseFloat(this.form.fee),1111);
      this.$set(this.form, 'fee', fee)
      // this.form.fee =
    },
    async saveClick() {
      const valid = await this.$refs.form.validate().catch(err => err);
      if (typeof valid === 'boolean' && valid) {
        if (this.form.ticketRestrictions !== 1) {
          const listNum = new Set(this.form.customers.map(item => item.name)).size;
          if (this.form.customers.length > listNum) {
            console.log("重复");
            this.$message.error('乘客信息重复')
            return
          }
        }


        const find = this.lines.find((item) => item.schedulingId === this.form.schedulingId)

        this.form.customers.forEach((item, index) => {
          item.isDefault = index === this.isDefault ? 1 : 2
        })

        const ticketArr = this.form.customers.filter((item) => [1, 2].includes(item.ticketType))

        if (ticketArr.length > find.remainingTickets) {
          this.$message.error('购票乘客数不能大于剩余票张数')
          return
        }

        const form = {
          ...this.form,
          customers: this.form.ticketRestrictions === 1 ? null : JSON.stringify(this.form.customers),
          lineId: find.lineId,
          startTime: find.startTime,
          endTime: find.endTime,
          orderFee: this.form.fee,
          railFee: find.fee,
          ticketReceiveId: this.ticketGetRow.id,
          ticketCurrentNo: this.ticketGetRow.ticketCurrentNo,
          ticketNum: this.form.ticketRestrictions === 1 ? this.form.passengerNum : ticketArr.length,
          passengerNum: this.form.ticketRestrictions === 1 ? this.form.passengerNum : this.form.customers.length,
          schedulingTime: Math.floor(this.form.schedulingTime / 1000),

        }

        const url = '/api/v1/manage/order/manage/station'
        const loading = this.$loading({
          lock: true,
          text: '出票中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        this.loading = true
        const { code, data } = await this.$axios.post(url, form)
        this.loading = false
        loading.close()
        if (code === 1) {
          form.ticketNum > 0 && this.getPrintList(data);

          // this.getEndInitFn()
          this.handChange(this.ticketGetRow)


          this.form.payChannel = 'CHANNEL_CASH'
          this.form.customers = []
          this.readIndex = 0
          this.form.passengerNum = 1
          console.log(this.form, 111);
          // this.$refs.form.resetFields();


        }


      } else {
        this.$message.error('请检查订单信息')
      }
    },
    /* 获取刚下单的票据打印列表 */
    getPrintList(id) {
      this.dialogVisible2 = true;
      this.printListLoading = true;
      this.printRowId = id
      this.getPrintListTimer = setInterval(async () => {
        let url = "/api/v1/manage/order/ticket/print/" + id;
        let data = await this.$axios.get(url);
        if (data?.code == 1 && data.data && data.data.length > 0) {
          this.printList = data.data.map((item) => {
            return {
              ...item,
              printNum: 0
            }
          });
          this.printListLoading = false;
          clearInterval(this.getPrintListTimer);
        }
      }, 1000);
    },
    /* 获取基础配置详情 */
    async getTicketRestrictions() {
      let url = "/api/v1/manage/order/manage/querySystemsConfig";
      let data = await this.$axios.get(url);
      if (data?.code == 1 && data.data) {
        this.systemOrderFeeChange = data.data.systemOrderFeeChange;
        this.stationTicketType = data.data.stationTicketType.split(',').map((item) => Number(item));
      }
    },
    deleteCustomer(num) {
      if (num === this.isDefault) {
        this.isDefault--
      }
      this.form.customers.splice(num, 1)
      this.readIndex--
    },
    /* 读卡 */
    readCard(index) {
      this.readIndexLook = index;
      this.readSwitch = true;
      this.cardReadInfo();
    },
    readCard2() {
      this.readSwitchNoUser = true;
      this.cardReadInfo();
    },

    schedulingChange() {
      const find = this.lines.find((item) => item.schedulingId === this.form.schedulingId)

      console.log(find, 22222);
      this.form.ticketRestrictions = find.ticketRestrictions
      this.form.customers = [{
        idCard: '',
        name: "",
        cardType: 1,
        phone: "",
        ticketType: 1,
        ticketFee: find.fee,
      }]
    },

    addCustomer() {
      const find = this.lines.find((item) => item.schedulingId === this.form.schedulingId)
      this.form.customers.push({
        idCard: '',
        cardType: 1,
        name: "",
        phone: "",
        ticketType: 1,
        ticketFee: find.fee,
      })
    },

    async getStartInitFn() {
      const url = "/api/v1/manage/order/manage/station";
      const { code, data } = await this.$axios.get(url, { appKey: this.mixinUserInfo?.appKey });
      if (code === 1 && data) {
        console.log(data, 111);
        this.startStations = data && data.map((item) => {
          return {
            ...item,
            newStationsName: `${item.mnemonicCode}-${item.stationName}`
          }
        })
        this.stationChange(this.startStations.length && this.startStations[0].stationCode)

      }
    },
    endStationChange(row) {
      this.form.endStationCode = row
      if (this.form.endStationCode) {
        const find = this.stationsList.find((item) => item.stationCode == row)
        if (find) {
          this.form.endStationCodeName = find.newStationsName
        }
      }
      this.timeChange()
    },
    async timeChange() {
      if (!(this.form.startStationCode && this.form.endStationCode)) {
        this.lines = []
        return
      }
      console.log(this.form, 111);
      this.form.schedulingId = ''
      const url = "/api/v1/manage/order/manage/station/scheduling";
      const { code, data } = await this.$axios.get(url, {
        startStationCode: this.form.startStationCode,
        endStationCode: this.form.endStationCode,
        schedulingTime: Math.floor(this.form.schedulingTime / 1000),
        appKey: this.mixinUserInfo?.appKey,
      })
      if (code === 1 && data) {
        this.lines = data
        this.$refs.f4Ref.visible = true
        this.$refs.f4Ref.focus()
      }
    },
    async stationChange(row) {
      console.log(row);
      this.form.startStationCode = row
      if (this.form.startStationCode) {
        const find = this.startStations.find((item) => item.stationCode == row)
        if (find) {
          this.form.startStationCodeName = find.newStationsName
        }
      }
      this.timeChange()
    },

    async getEndInitFn() {
      const url = "/api/v1/manage/station/base"
      const { code, data } = await this.$axios.get(url, {
        organizationId: this.mixinUserInfo.organizationId,
        page: 1,
        size: 999
      })
      if (code === 1 && data) {
        this.stationsList = data.map((item) => {
          return {
            ...item,
            newStationsName: `${item.mnemonicCode}-${item.stationName}`
          }
        })
        this.startStations = data.map((item) => {
          return {
            ...item,
            newStationsName: `${item.mnemonicCode}-${item.stationName}`
          }
        })
        const find = this.stationsList.find((item) => item.startStation == 1)
        if (find) {
          this.stationChange(find.stationCode)
        }


      }
    },

    refresh() {
      // this.getStartInitFn()
      this.getEndInitFn()
      this.handChange(this.ticketGetRow)
      this.lines = []
      this.form.endStationCodeName = ''
      this.form.endStationCode = ''
      this.form.payChannel = 'CHANNEL_CASH'
      this.form.customers = []
      this.readIndex = 0
      this.$refs.form.resetFields();
    },


    async handChange(row) {
      this.voteShow = false
      const url = '/api/v1/manage/ticket/receive/' + row.id
      const { code, data } = await this.$axios.get(url)
      if (code === 1) {
        this.ticketGetRow = data;
        if (this.ticketGetRow.remainingNum == 0) {
          this.voteShow = true
        }

      }
    }
  }
}
</script>

<style scoped lang="less">
#orderFormByChannel3 {
  width: 100%;
  position: fixed;
  height: calc(100% - 48px) !important;
  top: 48px;
  left: 0;
  box-sizing: border-box;
  background-color: #454545;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 100px;


  &>.orderFormByChannel3-div {
    width: 1000px;
    margin-top: 20px;
    padding: 20px;
    border-radius: 20px;
    background-color: #f3f4f5;
  }


  .orderFormByChannel3-header {
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
    display: flex;
    align-items: center;

    img {
      width: 24px;
      height: 24px;
      margin-right: 5px;
    }

    &:hover {
      color: #666;
    }
  }


  .ticketGetRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 17px;
    font-weight: bold;
  }

  .orderFormByChannel3-title {
    font-size: 30px;
    font-weight: bold;
  }

  .checkItem {
    margin-bottom: 0 !important;
  }

  .add {
    width: 100%;
    padding: 10px;
    margin-top: 20px;
    border: 1px #dcdfe6 dashed;
  }

  .orderFormByChannel3-user {
    /deep/ .el-radio__label {
      display: none;
    }
  }
}

::-webkit-scrollbar {
  width: 0px !important;
  height: 0px !important;

}

::v-deep .el-table .cell {
  height: 40px;
}
</style>
